"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function background() {
    return utils_1.map(arguments, function (background) {
        var s = '';
        if (background.image) {
            s += " " + background.image;
        }
        if (background.position) {
            s += " " + background.position;
        }
        if (background.size || background.size === 0) {
            s += " " + background.size;
        }
        if (background.repeat) {
            s += " " + background.repeat;
        }
        if (background.origin) {
            s += " " + background.origin;
        }
        if (background.clip) {
            s += " " + background.clip;
        }
        if (background.attachment) {
            s += " " + background.attachment;
        }
        if (background.color) {
            s += " " + background.color;
        }
        return s.trim();
    })
        .filter(function (s) { return s !== ''; })
        .join(',');
}
exports.background = background;
